(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
//信息
  let hasPush = [];
  let needToPushArr = [];
  //元素是否在屏幕内
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
var recommendationsCheck = function (){
  var productCount = document.getElementById('listing-count').getAttribute('data-listing-count');
  var fromListingId = document.getElementById('from-listing-id').getAttribute('data-from-listing-id');
  var shopId = document.getElementById('shop-id').getAttribute('data-shop-id');

  //清空数组
      needToPushArr.splice(0, needToPushArr.length);
      for(var i = 0; i < productCount; i++){
        var key = "ywy-recommendation-" + i;
        var el = document.getElementById(key);
        var listingId = document.getElementById(key).getAttribute('data-' + key);
        var isInView = isElementInViewport(el);

        //没有推送过且在可视范围内
        if(isInView && hasPush.indexOf(listingId) == -1) {
          needToPushArr.push(listingId);
          hasPush.push(listingId)
        }
      }
      if(needToPushArr.length > 0){
        var data = {
          sid: shopId,
          ids: needToPushArr.join(","),
          fid: fromListingId
        };
        fetch('https://sysback.hiywy.com/shopify/productRecommendationShow', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            "from-shopify": "12@#"
          },
        });
      }
};

var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      setInterval(recommendationsCheck, 2000);
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
    // recommendationCheck()
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ywy-featured-collection"] && !Shopify.designMode) return;
  try {
    
  //信息
  const fromListingId = document.querySelector('.ywy-recommendation').getAttribute('data-from-listing-id');
  const shopId = document.querySelector('.ywy-recommendation').getAttribute('data-shop-id');

  let hasPush = [];
  let needToPushArr = [];
  //元素是否在屏幕内
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function check(){

      //清空数组
      needToPushArr.splice(0, needToPushArr.length);

      document.querySelectorAll('.ywy-recommendation-product').forEach((el) => {
            var listingId = el.getAttribute('data-listing-id');
            var isInView = isElementInViewport(el);
            //没有推送过且在可视范围内
            if(isInView && hasPush.indexOf(listingId) == -1) {
                needToPushArr.push(listingId);
                hasPush.push(listingId)
            }
            if(needToPushArr.length > 0){
                var data = {
                sid: shopId,
                ids: needToPushArr.join(","),
                fid: fromListingId
                };
                fetch('https://sysback.hiywy.com/shopify/productRecommendationShow', {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        "from-shopify": "12@#"
                    },
                });
            }
      })

    }
  //6秒钟检查一次  
  setInterval(check, 2000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ywy-related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
